/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type CcmAccountOnboardedByEnum = 'SYSTEM' | 'OPERATOR';

export const CcmAccountOnboardedByEnum = {

    SYSTEM: 'SYSTEM' as CcmAccountOnboardedByEnum,

    OPERATOR: 'OPERATOR' as CcmAccountOnboardedByEnum
};

